<template>
  <div :class="[`x1-61`, className || ``]">
    <div class="group-245-1">
      <div class="group-50"><view792 :spanText1="view79Props.spanText1" :spanText2="view79Props.spanText2" /></div>
    </div>
    <group273 />
    <div class="text-47-1 poppins-semi-bold-black-14px">Урок 7 из 10</div>
  </div>
</template>

<script>
import View792 from "./View792";
import Group273 from "./Group273";
export default {
  name: "X1162",
  components: {
    View792,
    Group273,
  },
  props: ["className", "view79Props"],
};
</script>

<style>
.x1-61 {
  height: 367px;
  left: 0;
  position: absolute;
  top: 0;
  width: 532px;
}

.group-245-1 {
  align-items: flex-start;
  background-color: var(--white);
  border-radius: 20px;
  box-shadow: 0px 18.83px 47.08px #2f327d1a;
  display: flex;
  height: 367px;
  justify-content: flex-end;
  left: 0;
  min-width: 530px;
  padding: 19.6px 20.9px;
  position: absolute;
  top: 0;
}

.group-50 {
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/group-40-54@2x.png);
  background-size: 100% 100%;
  display: flex;
  height: 258px;
  position: relative;
  width: 488px;
}

.text-47-1 {
  left: 406px;
  letter-spacing: 0.28px;
  line-height: normal;
  position: absolute;
  top: 327px;
  width: 102px;
}

.x1-61.x1-62,
.x1-61.x1-67 {
  left: 553px;
  top: 1px;
}

.x1-61.x1-63 {
  left: 1115px;
  top: 2px;
}

.x1-61.x1-64,
.x1-61.x1-68 {
  left: 9px;
  top: 386px;
}

.x1-61.x1-65,
.x1-61.x1-69 {
  left: 562px;
  top: 387px;
}
</style>
